import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import weui from "weui.js";
import {
  IconSuccess,
  IconWarn,
  Loadmore,
  MediaBox,
  MediaBoxDesc,
  MediaBoxInfo,
  MediaBoxTitle,
  Panel,
  PanelBody
} from "../../components/weui";
import { userService } from "../../services";
import { urls } from "../../urls";
import { formatCurrency, formatDate, formatDateTime, getAxiosError } from "../../utils";

import "./index.css";

export const Message = (props) => {
  const navigate = useNavigate();

  const pageSize = 10;
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [messages, setMessages] = useState([]);

  const reload = useCallback(async () => {
    if (!hasMore) return;

    setLoading(true);
    try {
      const res = await userService.getPushMessages(page, pageSize);
      const newMessages = messages.concat(res.data.messages);
      setMessages(newMessages);
      setPage(page + 1);
      setHasMore(res.data.totalCount > newMessages.length);
    } catch (err) {
      weui.topTips(getAxiosError(err));
    } finally {
      setLoading(false);
    }
  }, [hasMore, setHasMore, setLoading, messages, setMessages, page, setPage]);

  useEffect(() => {
    if (page === 1) {
      reload();
    }
  }, [page, reload]);

  const renderOrder = (o, i) => {
    return <Panel access key={ i } >
      <MediaBox text>
        <PanelBody>
          <MediaBoxTitle>
            { o.messageTypeId === 2 && <IconSuccess className="mr-1" style={ { marginTop: "-2px" } }></IconSuccess> }
            { o.messageTypeId === 4 && <IconWarn className="mr-1" style={ { marginTop: "-2px" } }></IconWarn> }
            { o.messageType }
          </MediaBoxTitle>
          <MediaBoxDesc>{ o.message }</MediaBoxDesc>
          <MediaBoxInfo infos={ [`${o.meterNo}`, `|${formatDateTime(new Date(o.pushTime))}`] }></MediaBoxInfo>
        </PanelBody>
      </MediaBox>
    </Panel>;
  };

  return (
    <>
      { messages?.length > 0 && messages.map((o, i) => renderOrder(o, i)) }
      <Loadmore
        loading={ loading }
        line
        dot={ !hasMore }
        onClick={ e => hasMore && reload() }>
        { loading ? "加载中..." : "加载更多" }
      </Loadmore>
    </>
  );
};
